

























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import * as api from '@/api/api';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';

class ThreadBbsReplyData {
  public isOpenExtraOperations: boolean = false;

  public constructor(public readonly data: api.ThreadBbsReply) {}
}

@Component({
  components: {
    CharacterIcon,
    KmyChatTagText,
  },
})
export default class ThreadBbs extends Vue {
  @Prop() public countries!: api.Country[];
  @Prop() public threads!: api.ThreadBbsItem[];
  @Prop() public bbsType!: number;
  @Prop() public mutes!: api.Mute[];
  @Prop() public muteKeyword!: api.MuteKeyword;
  @Prop({
    default: 0,
  }) public characterId!: number;
  @Prop({
    default: false,
  }) public canRemoveAll!: boolean;
  @Prop({
    default: true,
  }) public canWrite!: boolean;
  @Prop({
    default: true,
  }) public canRemove!: boolean;

  private isUpdating: boolean = false;
  private replies: ThreadBbsReplyData[] = [];
  private newThread = new api.ThreadBbsReply();

  private getThreadReply(item: api.ThreadBbsItem): ThreadBbsReplyData {
    const reply = Enumerable
      .from(this.replies)
      .firstOrDefault((r) => r.data.parentId === item.id);
    if (reply !== undefined) {
      return reply;
    } else {
      const newReply = new api.ThreadBbsReply();
      newReply.parentId = item.id;
      const data = new ThreadBbsReplyData(newReply);
      this.replies.push(data);
      return data;
    }
  }

  private getItemCountry(item: api.ThreadBbsItem): api.Country {
    const country = Enumerable
      .from(this.countries)
      .firstOrDefault((c) => c.id === item.countryId);
    if (country !== undefined) {
      return country;
    } else {
      return api.Country.default;
    }
  }

  private write(item: api.ThreadBbsReply) {
    if (!item.text || item.text === '') {
      NotificationService.countryBbsPostFailedBecauseEmptyText.notify();
    } else if (!item.parentId && (!item.title || item.title === '')) {
      NotificationService.countryBbsPostFailedBecauseEmptyTitle.notify();
    } else {
      this.isUpdating = true;
      if (this.bbsType === 1) {
        api.Api.writeCountryBbsItem(item.text, item.parentId, item.title)
          .then(() => {
            NotificationService.countryBbsPosted.notify();
            item.title = '';
            item.text = '';
          })
          .catch(() => {
            NotificationService.countryBbsPostFailed.notify();
          })
          .finally(() => {
            this.isUpdating = false;
          });
      } else if (this.bbsType === 2) {
        api.Api.writeGlobalBbsItem(item.text, item.parentId, item.title)
          .then(() => {
            NotificationService.countryBbsPosted.notify();
            item.title = '';
            item.text = '';
          })
          .catch(() => {
            NotificationService.countryBbsPostFailed.notify();
          })
          .finally(() => {
            this.isUpdating = false;
          });
      }
    }
  }

  private remove(item: api.ThreadBbsItem) {
    this.isUpdating = true;
    if (this.bbsType === 1) {
      api.Api.removeCountryBbsItem(item.id)
        .then(() => {
          NotificationService.countryBbsRemoved.notify();
        })
        .catch(() => {
          NotificationService.countryBbsRemoveFailed.notify();
        })
        .finally(() => {
          this.isUpdating = false;
        });
    } else if (this.bbsType === 2) {
      api.Api.removeGlobalBbsItem(item.id)
        .then(() => {
          NotificationService.countryBbsRemoved.notify();
        })
        .catch(() => {
          NotificationService.countryBbsRemoveFailed.notify();
        })
        .finally(() => {
          this.isUpdating = false;
        });
    }
  }

  private isCharacterMuted(item: api.ThreadBbsItem): boolean {
    if (item.character) {
      const chara = item.character;
      return this.mutes.some((m) => m.targetCharacterId === chara.id);
    }
    return false;
  }

  private isMessageMuted(item: api.ThreadBbsItem): boolean {
    return api.MuteKeyword.isMute(this.muteKeyword, item.text);
  }

  private isReported(item: api.ThreadBbsItem): boolean {
    return this.mutes.some((m) => m.threadBbsItemId === item.id && m.type === api.Mute.typeReported);
  }

  private isShowForce(item: api.ThreadBbsItem) {
    const val = (item as any).isShowForce;
    if (val === undefined) {
      Vue.set(item, 'isShowForce', false);
    }
    return val;
  }

  private setShowForce(item: api.ThreadBbsItem, value: boolean) {
    Vue.set(item, 'isShowForce', value);
  }

  private muteCharacter(item: api.ThreadBbsItem, status: boolean) {
    if (item.character) {
      const chara = item.character;
      this.isUpdating = true;
      api.Api.muteCharacter(status ? api.Mute.typeMuted : api.Mute.typeNone, chara.id)
        .then(() => {
          NotificationService.muted.notify();
          (item as any).isShowForce = false;
        })
        .catch(() => NotificationService.muteFailed.notify())
        .finally(() => this.isUpdating = false);
    }
  }

  private reportMessage(item: api.ThreadBbsItem, status: boolean) {
    this.isUpdating = true;
    api.Api.reportThreadBbsItem(status ? api.Mute.typeReported : api.Mute.typeNone, item.id)
      .then(() => {
        NotificationService.reported.notify();
        (item as any).isShowForce = false;
      })
      .catch(() => NotificationService.reportFailed.notify())
      .finally(() => this.isUpdating = false);
  }
}
